var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-container"},[_c('div',{staticClass:"stepper-wrapper"},[_c('div',{staticClass:"progress",style:({ width: _vm.progressWidth })}),_vm._l((_vm.steps),function(step,i){return _c('div',{key:i},[_c('p',{staticClass:"caption",class:{
          completed: _vm.activeStep >= i + 1,
          first: i == 0,
          last: i == _vm.steps.length - 1
        }},[_vm._v("\n        "+_vm._s(step)+"\n      ")]),_c('div',{staticClass:"screen-indicator",class:{
          completed: _vm.activeStep >= i + 1,
          active: _vm.activeStep === i + 1 && _vm.activeStep != 1,
          last: i == _vm.steps.length - 1
        }})])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }